import { Checkbox } from 'primereact/checkbox';
import React, { useState } from 'react';
import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column, ColumnBodyOptions } from 'primereact/column';
import { AddListAttributeDialog } from './add-list-attribute-dialog';
import { Dialog } from 'primereact/dialog';
import { addClassAttributes } from './operations/add-class-attributes';
import { ClassAttributeType } from '../../../../../api/types/settings/class-attributes/class-attribute-types';

interface AddNewClassAttributesDialogDatamodel {
  onClose: () => any;
}

export const AddNewClassAttributesDialog: React.FC<
  AddNewClassAttributesDialogDatamodel
> = ({ onClose }) => {
  const [selectedAttribute, setSelectedAttribute] =
    useState<ClassAttributeType | null>(null);

  const [addAttribute, setAddAttributes] = useState(false);
  const [attributeName, setAttributeName] = useState('');
  const [attributeList, setAttributeList] = useState<string[]>([]);
  const [listName, setListName] = useState('');

  const handleSave = async () => {
    await addClassAttributes(
      listName,
      attributeName,
      selectedAttribute,
      onClose,
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Checkbox
            inputId="ingredient1"
            name="pizza"
            value=""
            onChange={() => setSelectedAttribute(ClassAttributeType.Bool)}
            checked={selectedAttribute === ClassAttributeType.Bool}
          />
          <label
            style={{ marginRight: '4px' }}
            htmlFor="ingredient1"
            className="ml-2"
          >
            בוליאני
          </label>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Checkbox
            inputId="ingredient1"
            name="pizza"
            value=""
            onChange={() => setSelectedAttribute(ClassAttributeType.Numeric)}
            checked={selectedAttribute === ClassAttributeType.Numeric}
          />
          <label
            style={{ marginRight: '4px' }}
            htmlFor="ingredient1"
            className="ml-2"
          >
            מספרי
          </label>
        </div>
      </div>

      <div style={{ marginTop: '16px' }} />

      <EditText title={'שם הרשימה'} onChange={setListName} />

      <EditText title={'שם התכונה'} onChange={setAttributeName} />

      <Dialog
        header="הוספת תכונה לכיתה"
        visible={addAttribute}
        onHide={() => setAddAttributes(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddListAttributeDialog
          onAttributeSave={(attributeValue) => {
            const arr = attributeList;
            arr.push(attributeValue);
            setAttributeList(arr);
            setAddAttributes(false);
          }}
        />
      </Dialog>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{
            height: '30px',
          }}
          label={'שמירה'}
          onClick={handleSave}
        />
      </div>
    </div>
  );
};
